import { render, staticRenderFns } from "./DevScreen.vue?vue&type=template&id=39d104ce&scoped=true&"
import script from "./DevScreen.vue?vue&type=script&lang=ts&"
export * from "./DevScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d104ce",
  null
  
)

export default component.exports